import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n            margin-left: ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n            margin-right: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        flex-shrink: 0;\n        position: relative;\n        top: -0.1em;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable no-use-before-define */


import * as React from "react";
import { Link } from "react-router-dom";
import { css, ClassNames } from "@emotion/core";
import tinycolor from "tinycolor2";
import { compose, get, space, width } from "styled-system";
import _shouldForwardProp from "@styled-system/should-forward-prop";
import { switchOn, rem, em, emRhythm, hideFocusRingOnClick } from "./css";
import { forwardInnerRef } from "./utils";
var defaultProps = {
  size: "md",
  tier: "default",
  variant: "solid",
  disabled: false,
  loading: false,
  full: false,
  iconPlacement: "left"
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onButtonPress", function (event) {
      var _this$props = _this.props,
          onPress = _this$props.onPress,
          disabled = _this$props.disabled,
          loading = _this$props.loading;
      if (!disabled && !loading && onPress) return onPress(event);
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var propsWithDefaults = _extends({}, defaultProps, _this.props);

      var to = propsWithDefaults.to,
          fullNavigation = propsWithDefaults.fullNavigation,
          disabled = propsWithDefaults.disabled,
          loading = propsWithDefaults.loading,
          full = propsWithDefaults.full,
          icon = propsWithDefaults.icon,
          iconPlacement = propsWithDefaults.iconPlacement,
          onPress = propsWithDefaults.onPress,
          children = propsWithDefaults.children,
          typeProp = propsWithDefaults.type,
          innerRef = propsWithDefaults.innerRef,
          props = _objectWithoutPropertiesLoose(propsWithDefaults, ["to", "fullNavigation", "disabled", "loading", "full", "icon", "iconPlacement", "onPress", "children", "type", "innerRef"]);

      var href = propsWithDefaults.href;
      var as;
      var type;
      var role;

      if (to != null) {
        if (fullNavigation) {
          as = "a";
          href = to;
        } else {
          as = Link;
        }

        role = "button";
      } else if (href != null) {
        as = "a";
        role = "button";
      } else {
        type = typeProp || "button";
      }

      return ___EmotionJSX(ClassNames, null, function (_ref) {
        var cx = _ref.cx,
            css = _ref.css,
            theme = _ref.theme;
        var styledIcon = createStyledIcon(icon, iconPlacement, cx, css, theme);
        return ___EmotionJSX(StyledButton, _extends({
          onClick: _this.onButtonPress,
          as: as,
          to: to,
          disabled: loading || disabled,
          loading: loading ? true : undefined,
          width: full ? 1 : undefined,
          role: role,
          type: type,
          ref: innerRef
        }, props, {
          href: href
        }), iconPlacement === "left" && styledIcon, children, iconPlacement === "right" && styledIcon);
      });
    });

    return _this;
  }

  return Button;
}(React.Component);

function createStyledIcon(icon, iconPlacement, cx, // eslint-disable-next-line no-shadow
css, theme) {
  if (!icon) return null;
  return React.cloneElement(icon, {
    size: "1em",
    className: cx(css(_templateObject()), iconPlacement === "left" ? css(_templateObject2(), theme.space.xs) : css(_templateObject3(), theme.space.xs))
  });
}

var getCursor = function getCursor(_ref2) {
  var loading = _ref2.loading,
      disabled = _ref2.disabled;
  if (loading) return "progress";
  if (disabled) return "not-allowed";
  return "pointer";
};

function getButtonColor(_ref3) {
  var buttonColor = _ref3.buttonColor,
      tier = _ref3.tier,
      theme = _ref3.theme;
  if (buttonColor) return get(theme.colors, buttonColor, buttonColor);
  return switchOn(tier || defaultProps.tier, {
    default: theme.colors.grays[100],
    emphasis: theme.colors.blue,
    alert: theme.colors.red
  }, theme.colors.grays[100]);
}

function getTextColor(backgroundColor, preferredTextColor, fallbackColor) {
  return tinycolor.isReadable(backgroundColor, preferredTextColor, {
    size: "large"
  }) ? preferredTextColor : fallbackColor;
}

var StyledButton =
/*#__PURE__*/
_styled("button", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "loading" && _shouldForwardProp(prop);
  },
  target: "e1cybreo0"
})(function (props) {
  var size = props.size,
      theme = props.theme;
  var background = getButtonColor(props);
  var color = getTextColor(background, "white", theme.colors.heading);
  return (
    /*#__PURE__*/
    css("label:base;border-radius:", theme.radii.lg, ";text-decoration:none;font-family:", theme.fonts.heading, ";font-size:", switchOn(size || defaultProps.size, {
      sm: rem(12),
      md: rem(14),
      lg: rem(16)
    }, rem(14)), ";line-height:", emRhythm(1, 14), ";padding:", em(7, 14), " ", em(19, 14), " ", em(4, 14), ";display:inline-flex;align-items:center;justify-content:center;text-align:center;transition:transform 10ms ease,all 75ms ease-in-out;transform:translateY(-3px);transform-origin:center bottom;cursor:", getCursor(props), ";background-color:", background, ";color:", color, ";border:1px solid ", background, ";box-shadow:0 0.15em 0.15em rgba(0,0,0,0) inset,0 3px 0 ", tinycolor(background).darken(15).toHexString(), ";&:hover{background-color:", tinycolor(background).lighten(8).toHexString(), ";color:", color, ";}&:active{background-color:", tinycolor(background).lighten(8).toHexString(), ";color:", color, ";box-shadow:0 0.15em 0.15em rgba(0,0,0,50%) inset,0 0 0 ", tinycolor(background).darken(22).toHexString(), ";transform:translateY(0) scale(0.95);}&[disabled],&[disabled]:hover,&[disabled]:active{background-color:", tinycolor(background).desaturate(30).lighten(5).toHexString(), ";color:", color, ";box-shadow:none;transform:none;transition:none 0;}")
  );
}, function (props) {
  if (props.variant !== "outline") return null;
  var background = getButtonColor(props);
  var color = getTextColor("white", background, props.theme.colors.heading);
  return (
    /*#__PURE__*/
    css("label:with-outline;box-shadow:none;background:transparent;transform:none;border:1px solid ", background, ";color:", color, ";")
  );
}, hideFocusRingOnClick, compose(space, width));

export default forwardInnerRef(Button);